const disabled = {
  label: 'Disabled',
  name: 'disabled',
  component: 'toggle'
}

export default disabled
